import { render, staticRenderFns } from "./PointsManageDialog.vue?vue&type=template&id=bdc4e618&scoped=true&"
import script from "./PointsManageDialog.vue?vue&type=script&lang=js&"
export * from "./PointsManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc4e618",
  null
  
)

export default component.exports